import React, { useState, useEffect } from "react";
import MainImage from "../Components/MainImage";
import pic from "../Media/payyyyy.png";
import { Box, Container, Typography, Stack } from "@mui/material";
import SmallBtns from "../Components/SmallBtns";
import cc from "../Media/wall-clock.png";
import cc2 from "../Media/safe.png";
import cc3 from "../Media/card-payment.png";
import MiniCards from "../Components/MiniCards";
import OurGoal from "../Components/OurGoal";
import c from "../Media/electronic-payyyyyyy.png";
import c2 from "../Media/electronic-paymentttt.png";
import db from "../DbFile.json";
import ServicesCard from "../Components/ServicesCard";
import Questions from "../Components/Questions";
import { useTranslation } from "react-i18next";

export default function PayAnyOne({ setTheState }) {
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.Pay_Q);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(false);
  }, []);
  return (
    <div>
      <MainImage image={pic} txt1={"Send,Speed"} txt2={"Simple."} />
      <Container>
        <Box
          sx={{
            marginTop: "3%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
          >
            {t("Pay")}
          </Typography>
        </Box>
        <Box
          gap={4}
          sx={{
            marginTop: "3%",
            marginBottom: "4%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SmallBtns txt={"Pay"} name={"PayAnyOne"} />
          <SmallBtns txt={"Packages"} name={"Packages"} />
        </Box>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "60px",
          }}
        >
          <MiniCards
            imgg={cc}
            txt={"Pay Cash"}
            txt2={"Pay cash immediately to our driver after the trip end"}
          />
          <MiniCards
            imgg={cc3}
            txt={"Elctronic Payment"}
            txt2={"Use your cridet card or wallet balance to pay for your trip"}
          />
          <MiniCards
            imgg={cc2}
            txt={"Safe and Secure"}
            txt2={"Our product is built to protect your cards and money"}
          />
        </div>
      </Container>

      <OurGoal
        caption={"Elctronic Payment"}
        im={c}
        btn={"Book your ride"}
        txt={
          "Pay your trip costs electronically through the payment companies we contract with"
        }
      />

      <Stack
        direction="column"
        sx={{
          display: "flex",
          marginBottom: "5%",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "30px",
            color: "#1D2877",
            marginBottom: "2%",
          }}
        >
          {t("Electronic payment companies")}
        </Typography>
        <img alt="img854712" src={c2} style={{ width: "70%" }} />
      </Stack>

      <Box
        sx={{
          marginTop: "5%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "40px",
              color: "#1D2877",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("Explore more with Mashawiri")}
          </Typography>
          {el && <ServicesCard el={el.filter((el) => el.id !== 4)} />}
        </Stack>
      </Box>

      <Questions questions={Qs} />
    </div>
  );
}
